import React, { useEffect } from "react";
import { Row } from "react-bootstrap";
import "react-image-gallery/styles/css/image-gallery.css";
import "./index.css";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const accountBanner = (
    <div className="privacy-policy-banner-main-div text-uppercase desktop">
      <p>
        {" "}
        <Link to={`/`}>{"Home "}</Link>
      </p>
      <h2>{"Privacy Policy"}</h2>
    </div>
  );

  return (
    <section className="privacy-policy-main-section">
      {accountBanner}
      <div className="privacy-policy-conatiner container py-5">
        <Row className="m-0">
          <h2>{"Privacy Policy"}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h2>
          <p>
            {
              "We value the trust you place in us. That's why we insist upon the highest standards for secure transactions and customer information privacy. Please read the following statement to learn about our information gathering and dissemination practices."
            }{" "}
            <br />{" "}
            {
              "Note: Our privacy policy is subject to change at any time without notice. To make sure you are aware of any changes, please review this policy periodically."
            }
            <br />
            {
              "By visiting this Website, you agree to be bound by the terms and conditions of this Privacy Policy. If you do not agree please do not use or access our Website."
            }
            <br />
            {
              "By mere use of the Website, you expressly consent to our use and disclosure of your personal and business information in accordance with this Privacy Policy. This Privacy Policy is incorporated into and subject to the Terms of Use"
            }
          </p>

          <h6>{"1. Collection of Personally Identifiable Information and other Information"}</h6>
          <p>
            {
              "When you use our Website, we collect and store your personal and business information which is provided by you from time to time. Our primary goal in doing so is to provide you a safe, efficient, smooth and customized experience. This allows us to provide services and features that most likely meet your needs, and to customize our Website to make your experience safer and easier. More importantly, while doing so we collect personal and business information from you that we consider necessary for achieving this purpose."
            }
            <br />
            {
              "In general, you can browse the Website without telling us who you are or revealing any personal and business information about yourself. Once you give us your personal and business information, you are not anonymous to us. Where possible, we indicate which fields are required and which fields are optional. You always have the option to not provide information by choosing not to use a particular service or feature on the Website. We may automatically track certain information about you based upon your behaviour on our Website. We use this information to do internal research on our users' demographics, interests, and behaviour to better understand, protect and serve our users. This information is compiled and analysed on an aggregated basis. This information may include the URL that you just came from (whether this URL is on our Website or not), which URL you next go to (whether this URL is on our Website or not), your computer browser information, and your IP address."
            }
            <br />
            {
              'We use data collection devices such as "cookies" on certain pages of the Website to help analyse our web page flow, measure promotional effectiveness, and promote trust and safety. "Cookies" are small files placed on your hard drive that assist us in providing our services. We offer certain features that are only available through the use of a "cookie". We also use cookies to allow you to enter password less frequently during a session. Cookies can also help us provide information that is targeted to your interests. Most cookies are "session cookies," meaning that they are automatically deleted from your hard drive at the end of a session. You are always free to decline our cookies if your browser permits, although in that case you may not be able to use certain features on the Website and you may be required to re-enter your password more frequently during a session.'
            }
            <br />
            {
              'Additionally, you may encounter "cookies" or other similar devices on certain pages of the Website that are placed by third parties. We do not control the use of cookies by third parties.'
            }
            <br />
            {
              "If you choose to buy on the Website, we collect information about your buying behaviour."
            }
            <br />
            {
              "If you transact with us, we collect some additional information, such as a billing address, a credit / debit card number and a credit / debit card expiration date and/ or other payment instrument details and tracking information from cheques or money orders."
            }
            <br />
            {
              "If you choose to post messages on our message boards, chat rooms or other message areas or leave feedback, we will collect that information you provide to us. We retain this information as necessary to resolve disputes, provide customer support and troubleshoot problems as permitted by law."
            }
            <br />
            {
              "If you send us personal correspondence, such as emails or letters, or if other users or third parties send us correspondence about your activities or postings on the Website, we may collect such information into a file specific to you."
            }
            <br />
            {
              " We collect personally identifiable information (email address, name, phone number, credit card / debit card / other payment instrument details, etc.) from you when you set up a free account with us. While you can browse some sections of our Website without being a registered member, certain activities (such as placing an order) do require registration. We do use your contact information to send you offers based on your previous orders and your interests"
            }
          </p>
          <h6>{"2. Use of Demographic / Profile Data / Your Information"}</h6>
          <p>
            {
              "We use personal and business information to provide the services you request. To the extent we use your personal and business information to market to you, we will provide you the ability to opt-out of such uses. We use your personal and business information to resolve disputes; troubleshoot problems; help promote a safe service; collect money; measure consumer interest in our products and services, inform you about online and offline offers, products, services, and updates; customize your experience; detect and protect us against error, fraud and other criminal activity; enforce our terms and conditions; and as otherwise described to you at the time of collection."
            }{" "}
            <br />
            {
              "In our efforts to continually improve our product and service offerings, we collect and analyse demographic and profile data about our users' activity on our Website."
            }
            <br />
            {
              "We identify and use your IP address to help diagnose problems with our server, and to administer our Website. Your IP address is also used to help identify you and to gather broad demographic information."
            }
            <br />
            {
              "We will occasionally ask you to complete optional online surveys. These surveys may ask you for contact information and demographic information (like zip code, age, or income level). We use this data to tailor your experience at our Website, providing you with content that we think you might be interested in and to display content according to your preferences."
            }
            <br />
            {"Cookies"}
            <br />A "cookie" is a small piece of information stored by a web server on a web browser
            so it can be later read back from that browser. Cookies are useful for enabling the
            browser to remember information specific to a given user. We place both permanent and
            temporary cookies in your computer's hard drive. The cookies do not contain any of your
            personally identifiable information
          </p>
          <h6>{"3. Use of Demographic / Profile Data / Your Information"}</h6>
          <p>
            {
              "We may share personal and business information with our other corporate entities and affiliates. These entities and affiliates may market to you as a result of such sharing unless you explicitly opt-out."
            }
            <br />
            {
              "We may disclose personal and business information to third parties. This disclosure may be required for us to provide you access to our Services, to comply with our legal obligations, to enforce our User Agreement, to facilitate our marketing and advertising activities, for service recovery purposes, or to prevent, detect, mitigate, and investigate fraudulent or illegal activities related to our Services. We do not disclose your personal and business information to third parties for their marketing and advertising purposes without your explicit consent."
            }
            <br />
            {
              " We may disclose personal and business information if required to do so by law or in the good faith belief that such disclosure is reasonably necessary to respond to subpoenas, court orders, or other legal process. We may disclose personal and business information to law enforcement offices, third party rights owners, or others in the good faith belief that such disclosure is reasonably necessary to: enforce our Terms or Privacy Policy; respond to claims that an advertisement, posting or other content violates the rights of a third party; or protect the rights, property or personal safety of our users or the general public."
            }
            <br />
            {
              "We and our affiliates will share / sell some or all of your personal and business information with another business entity should we (or our assets) plan to merge with, or be acquired by that business entity, or re-organization, amalgamation, restructuring of business. Should such a transaction occur that other business entity (or the new combined entity) will be required to follow this privacy policy with respect to your personal and business information"
            }
          </p>
          <h6>{"4. Links to Other Sites"}</h6>
          <p>
            {
              "Our Website links to other websites that may collect personally identifiable information about you. Bharee.com is not responsible for the privacy practices or the content of those linked websites"
            }
          </p>
          <h6>{"5. Security Precautions"}</h6>
          <p>
            {
              "Our Website has stringent security measures in place to protect the loss, misuse, and alteration of the information under our control. Whenever you change or access your account information, we offer the use of a secure server. Once your information is in our possession we adhere to strict security guidelines, protecting it against unauthorized access."
            }
          </p>
          <h6>{"6. Choice/Opt-Out"}</h6>
          <p>
            {
              "We provide all users with the opportunity to opt-out of receiving non-essential (promotional, marketing-related) communications from us on behalf of our partners, and from us in general, after setting up an account."
            }
          </p>
          <h6>{"7. Advertisements on Bharee.com"}</h6>
          <p>
            {
              "We use third-party advertising companies to serve ads when you visit our Website. These companies may use information (not including your name, address, email address, or telephone number) about your visits to this and other websites in order to provide advertisements about goods and services of interest to you."
            }
          </p>
          <h6>{"8. Your Consent"}</h6>
          <p>
            {
              "By using the Website and/ or by providing your information, you consent to the collection and use of the information you disclose on the Website in accordance with this Privacy Policy, including but not limited to Your consent for sharing your information as per this privacy policy."
            }
            <br />
            {
              "If we decide to change our privacy policy, we will post those changes on this page so that you are always aware of what information we collect, how we use it, and under what circumstances we disclose it."
            }
          </p>
          <h6>{"9. Grievance Officer"}</h6>
          <p>
            {
              "In accordance with Information Technology Act 2000 and rules made there under, the name and contact details of the Grievance Officer are provided below:"
            }
          </p>
          <h6>{"Bharee Beverages Ecom Pvt. Ltd."}</h6>
          <p>
            {"Office No-219 & 220, Jai Ganesh Vision Akurdi Pune-411035 Maharashtra, India"}
            <br />
            {"Email: support@bharee.com"}
          </p>
        </Row>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
